import types from '@/actions/types';
import useR2RChat from '@/composables/useR2RChat';
import Base from '@/actions/base';
import useAnalytics from '@/composables/useAnalytics';

export default class RobotAction extends Base {
  constructor(params) {
    super(params, types.ROBOT_ACTION);
  }

  execute() {
    const { stopChat, switchRobot, ROBOT_ACTIONS } = useR2RChat();
    const { trackAction } = useAnalytics();
    trackAction(this);

    return new Promise((resolve) => {
      if (this.params.action === ROBOT_ACTIONS.ROBOT_CHAT_SWITCH) {
        switchRobot();
      } else if (this.params.action === ROBOT_ACTIONS.END_CHAT) {
        stopChat();
      } else {
        // eslint-disable-next-line
        console.error('Non supported action! flow will stuck here!');
      }

      this.resolve = resolve;
    });
  }

  stop() {
    if (this.resolve) {
      this.resolve();
    }
  }
}
